import richTextInitialHtml from "./rich_text_initial_html"

export default class CalloutStatTool {
  static get enableLineBreaks() {
    return true
  }

  static get toolbox() {
    return {
      title: "Callout stat",
      icon: "<span class=\"icon-[lucide--chart-column] size-4\"></span>"
    }
  }

  static get sanitize() {
    return {
      number: false,
      text: {
        br: true,
        div: true
      }
    }
  }

  constructor({ data, readOnly } = {}) {
    this.readOnly = Boolean(readOnly)
    this.data = {
      number: data?.number || "",
      text: data?.text || ""
    }
    this.wrapper = null
    this.numberInput = null
    this.textInput = null
  }

  render() {
    this.wrapper = document.createElement("div")
    this.wrapper.className = "editorjs-callout-stat"

    this.numberInput = document.createElement("input")
    this.numberInput.type = "text"
    this.numberInput.placeholder = "42"
    this.numberInput.className = "editorjs-callout-stat__number"
    this.numberInput.value = this.data.number

    this.textInput = document.createElement("div")
    this.textInput.className = "editorjs-callout-stat__text"
    this.textInput.setAttribute("data-placeholder", "Stat description")
    this.textInput.contentEditable = this.readOnly ? "false" : "true"
    this.textInput.innerHTML = richTextInitialHtml(this.data.text)

    this.wrapper.append(this.numberInput, this.textInput)
    return this.wrapper
  }

  save() {
    return {
      number: this.numberInput?.value || "",
      text: this.textInput?.innerHTML || ""
    }
  }

  validate(savedData) {
    const number = (savedData?.number || "").trim()
    const tmp = document.createElement("div")
    tmp.innerHTML = savedData?.text || ""
    const text = (tmp.textContent || "").trim()
    return Boolean(number || text)
  }
}
